import(/* webpackMode: "eager" */ "/codebuild/output/src716910490/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
